import React from "react";
import { Button, Dropdown, Input, Menu, message } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { usePurchaseRoModel } from "../purchaseRoModel";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { usePurchaseRoDetailsModel } from "./details/purchaseRoDetailsModel";
import { AuthButton } from "@/components/auth/AuthButton";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { ResourcesAuthBtn } from "@/types/ResourcesAuthEnum";
import { mianCode } from "@/utils/constants";
import { DownOutlined } from "@ant-design/icons";
import { formatNum } from "@/utils/utils";

export const DataBox = () => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const { setDetailDataSource, setDetailEditForm, Settle, WhConfirm } = usePurchaseRoDetailsModel();

    const { selectedRowKeys, selectedRow, invalidateData, loadData, detailsExport, listExport, descTotal, rowsDescTotal } = usePurchaseRoModel();
    const { selectedNavId, addNav, findNav, selectNav, switchNavState, replaceNav } = useNavModel();

    const onEdit = () => {
        if (selectedRow.status == "purchase-return.change") {
            // globalPrompt("message", { text: "该单据已作废，无法进行编辑", type: "warning" });
            globalPrompt("message", { text: Locale["The document has been cancelled and cannot be edited."], type: "warning" });

            return;
        }
        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行编辑", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" });

            return;
        }
        let supplierEditKey = "3-2-2";
        let isFindNav = findNav(supplierEditKey);
        if (!isFindNav) {
            addNav(supplierEditKey, { id: selectedRow.returnCode as string, mode: "edit" });
        } else {
            globalPrompt("modal", {
                // title: "采购退货跳转详情",
                title: Locale["Jump to the detail page of Purchase Return doc."],
                type: "warning",
                // text: "您还有采购退货单详情未保存，是否跳转",
                text: Locale["The detail page of Purchase Return doc has not been saved. Do you still want to jump?"],
                // okText: "跳转未保存页",
                okText: Locale["Jump to the unsaved page"],
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                // cancelText: "打开新页签",
                cancelText: Locale["Open a new page"],
                onCancel: () => {
                    switchNavState(supplierEditKey, { id: selectedRow.returnCode as string, mode: "edit" });
                    setDetailDataSource([])
                    setDetailEditForm({})
                }
            })
        }
    }
    const onLook = () => {
        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行查看", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data to view."], type: "warning" });
            return;
        }
        let supplierEditKey = "3-2-3";
        replaceNav(
            selectedNavId,
            "3-2-3",
            { id: selectedRow.returnCode as string, mode: "look", },
            true
        );
    }
    const cancellation = async () => {
        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行作废", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data for cancellation."], type: "warning" });
            return;
        }
        let val: string = ""
        globalPrompt("modal", {
            // title: "采购退货单作废",
            title: Locale["Cancel the Purchase Return doc."],
            type: "error",
            text: "",
            // okText: "确定",
            okText: Locale["Yes No"],
            onOk: () => {
                let obj = {
                    id: selectedRow.id,
                    returnCode: selectedRow.returnCode
                }
                invalidateData(obj)
            },
            // cancelText: "取消",
            cancelText: Locale["cancel"],
            onCancel: () => {
            }
        })
    }
    const onSettle = async () => {
        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行操作", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" });
            return;
        }
        let { returnCode, id } = selectedRow
        globalPrompt("modal", {
            // title: "采购退货单结算",
            title: Locale["Settle the Purchase Return doc."],
            type: "success",
            text: "",
            // <><span>请输入作废原因</span>
            //     <Input onChange={(e) => { val = e.target.value }} /></>,
            // okText: "确定",
            okText: Locale["Yes No"],
            onOk: async () => {
                let retData = await Settle({ returnCode, id })
                // retData ? message.success("c") && loadData() : message.error("结算失败")
                retData ? message.success(Locale["Successfully settled"]) && loadData() : message.error(Locale["Unsuccessfully settled"])

            },
            // cancelText: "取消",
            cancelText: Locale["cancel"],
            onCancel: () => {
            }
        })
        // let retData = await Settle({ id, returnCode })
        // retData ? message.success("结算成功") : message.error("结算失败")
    }
    const onWhConfirm = async () => {
        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行操作", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" });

            return;
        }
        let { returnCode, id } = selectedRow

        globalPrompt("modal", {
            // title: "采购退货单出库",
            title: Locale["Stock out the Purchase Return doc."],
            type: "success",
            text: "",
            // <><span>请输入作废原因</span>
            //     <Input onChange={(e) => { val = e.target.value }} /></>,
            // okText: "确定",
            okText: Locale["Yes No"],
            onOk: async () => {
                let retData = await WhConfirm({ returnCode, id })
                // retData ? message.success("出库成功") && loadData() : message.error("出库失败")
                retData ? message.success(Locale["Successfully stocked out"]) && loadData() : message.error(Locale["Unsuccessfully stocked out"])
            },
            // cancelText: "取消",
            cancelText: Locale["cancel"],
            onCancel: () => {
            }
        })
        // let retData = await WhConfirm({ id, returnCode })
        // retData ? message.success("出库成功") : message.error("出库失败")
    }
    const onExport = () => {
        listExport().then()
    }
    const MenuExport = () => {
        return (
            <Menu>
                <Menu.Item key="0">
                    <span onClick={onExport}>{Locale["List export"]}</span>
                </Menu.Item>
                <Menu.Item key="1">
                    <span onClick={detailsExport}>{Locale["Details export"]}</span>
                </Menu.Item>
            </Menu>
        )
    }
    const action = <>
        <AuthButton
            // resCode="PurchaseReturnAdd"
            resCode={ResourcesAuthBtn[mianCode]["PurchaseReturnAdd"]}
            onClick={() => addNav("3-2-1", { id: "", mode: "add" })}
            // name="新增"
            name={Locale["Add"]}
        />
        <AuthButton
            // resCode="PurchaseReturnEdit"
            resCode={ResourcesAuthBtn[mianCode]["PurchaseReturnEdit"]}
            onClick={onEdit}
            // name="编辑"
            name={Locale["Edit"]}
        />
        <AuthButton
            // resCode="PurchaseReturnView"
            resCode={ResourcesAuthBtn[mianCode]["PurchaseReturnView"]}
            onClick={onLook}
            // name="查看"
            name={Locale["View"]}
        />
        <AuthButton
            // resCode="PurchaseReturnStockout"
            resCode={ResourcesAuthBtn[mianCode]["PurchaseReturnStockout"]}
            onClick={onWhConfirm}
            // name="出库"
            name={Locale["Stock out"]}
        />
        <AuthButton
            // resCode="PurchaseReturnPayment"
            resCode={ResourcesAuthBtn[mianCode]["PurchaseReturnPayment"]}
            onClick={onSettle}
            // name="结算"
            name={Locale["Settle"]}
        />
        <AuthButton
            // resCode="PurchaseReturnCancel"
            resCode={ResourcesAuthBtn[mianCode]["PurchaseReturnCancel"]}
            onClick={cancellation}
            // name="作废"
            name={Locale["Cancel"]}
        />
        <Dropdown overlay={MenuExport}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
            >{Locale["export"]}<DownOutlined /></Button>
        </Dropdown>
        {/* <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => addNav("3-2-1", { id: "", mode: "add" })}
        >新增</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            // disabled={selectedRow?.status == "purchase-return.change" || selectedRow?.status == "purchase-return.stock-io"}
            onClick={onEdit}
        >编辑</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onLook}
        >查看</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => onWhConfirm()}
        >出库</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => onSettle()}
        >结算</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => cancellation()}
        >作废</Button> */}
    </>;

    const desc: IDescription[] = [
        {
            // label: "采退数量",
            label: Locale["Purchase Return Qty"],
            value: selectedRowKeys.length === 0 ? descTotal.totalNum : (rowsDescTotal.totalNum),
            color: DescriptionColorEnum.red
        },
        {
            // label: "退货金额",
            label: Locale["Return Amount"],
            value: selectedRowKeys.length === 0 ? descTotal.totalAmount : formatNum(rowsDescTotal.totalAmount),
            color: DescriptionColorEnum.red
        },
        {
            // label: "应收金额",
            label: Locale["Receivable Amount"],
            value: selectedRowKeys.length === 0 ? descTotal.receivedAmount : formatNum(rowsDescTotal.receivedAmount),
            color: DescriptionColorEnum.red
        },
        {
            // label: "已收金额",
            label: Locale["Received Amount"],
            value: selectedRowKeys.length === 0 ? descTotal.amountReceived : formatNum(rowsDescTotal.amountReceived),
            color: DescriptionColorEnum.red
        },
    ]
    return (
        <YhBox title={<></>} descriptions={desc} action={action} >
            <DataTable />
        </YhBox>
    )
}